// RSA加密
// import JSEncrypt from '@/utils/jsencrypt.min';
import JSEncrypt from 'jsencrypt/bin/jsencrypt.min';


export function getRsaCode(str) { // 注册方法
                                  // return str;

  let pubKey = `MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCwXGPWuKzIVOtRaLvL5j8Pd6MHvauxN9/JC0DYcrw0ryX4KUyprsP3kEtHbH40aYOkVjWGPgah9UsyFKv3P5GxqjcRcWiF3JMgAkkB1us/utfEPyxJqXzxQ0ssxw6yiN3UQXSVEbipiqdPoAsoWiIOZ6xy77l6fOvjJCRhLq0nYwIDAQAB`; // ES6 模板字符串 引用 rsa 公钥
  // // console.log('pubKey', pubKey)
  let encryptStr = new JSEncrypt();
  encryptStr.setPublicKey(pubKey); // 设置 加密公钥
  let data = encryptStr.encrypt(str.toString());  // 进行加密
  return data;
}


